// Short-loop goals give the player a satisfying next step between long idle
// intervals. Targets rise with each completed round so a claimed order never
// becomes an infinite one-click reward.
export const COMMAND_ORDERS = [
  {
    id: 'formation',
    label: 'BUILD THE FORMATION',
    description: 'Book enough units to turn a watch section into a proper formation.',
    progressLabel: 'UNITS BOOKED',
    targetFor: (round) => 4 + (round * 3),
    rewardFor: (round) => 100 * (1.65 ** round),
    glimmerFor: (round) => 2 + round,
    progressFor: (state) => Object.values(state.units || {}).reduce((total, count) => total + Number(count || 0), 0),
  },
  {
    id: 'doctrine',
    label: 'ADOPT A DOCTRINE',
    description: 'Choose one upgrade that makes the next watch more capable.',
    progressLabel: 'UPGRADES ADOPTED',
    targetFor: (round) => 1 + round,
    rewardFor: (round) => 180 * (1.65 ** round),
    glimmerFor: (round) => 3 + round,
    progressFor: (state) => (state.upgrades || []).length,
  },
  {
    id: 'promotion',
    label: 'EARN THE NEXT STRIPE',
    description: 'Keep the island moving until the next rank is within reach.',
    progressLabel: 'CURRENT RANK',
    targetFor: (round) => 2 + round,
    rewardFor: (round) => 260 * (1.65 ** round),
    glimmerFor: (round) => 4 + round,
    progressFor: (state) => Number(state.rankIndex || 0),
  },
];

export function commandFor(index = 0) {
  const safeIndex = Math.max(0, Number(index) || 0);
  return { ...COMMAND_ORDERS[safeIndex % COMMAND_ORDERS.length], index: safeIndex, round: Math.floor(safeIndex / COMMAND_ORDERS.length) };
}

// At very high single-enlistment rank the escalating targets can outrun their
// own ceilings — a 'doctrine' order needing more upgrades than exist, or a
// 'promotion' order needing a rank past the ladder. Those can never be claimed,
// which would stall the whole track. The caller skips past any such order; only
// 'formation' (unbounded unit count) is always reachable, so the skip always
// lands somewhere claimable.
export function orderReachable(order, maxUpgrades, maxRankIndex) {
  const target = order.targetFor(order.round);
  if (order.id === 'doctrine') return target <= maxUpgrades;
  if (order.id === 'promotion') return target <= maxRankIndex;
  return true;
}
